/* eslint-disable no-case-declarations */
import {
  FETCH_EPG_LINE_UP_ERROR,
  FETCH_EPG_LINE_UP_INIT,
  FETCH_EPG_LINE_UP_SUCCESS,
} from '../actions/epgLineUp';
const dataLineUp = JSON.parse(localStorage.getItem('epgLineUp'));
const initialState = {
  inProgress: false,
  success: false,
  data: dataLineUp?.channels?.length > 0 ? dataLineUp?.channels : [],
  error: null,
  quantity: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EPG_LINE_UP_INIT:
      return {
        ...state,
        inProgress: true,
        success: false,
        data: [],
        error: null,
      };
    case FETCH_EPG_LINE_UP_SUCCESS:
      return {
        ...state,
        inProgress: false,
        success: true,
        data: action.payload,
        error: null,
        quantity: action.quantity,
      };
    case FETCH_EPG_LINE_UP_ERROR:
      return {
        ...state,
        inProgress: false,
        success: false,
        data: [],
        error: action.error,
      };
    default:
      return state;
  }
};
